import RoleTable from './RoleTable';

export default RoleTable;
